export default __webpack_public_path__ + "05e69762031be306247ba1ae7538ee69.png";